<template>
  <div
    class="card is-radiusless material-card"
    @click="handleClick(resourceType, resourceId)"
  >
    <div class="card-image">
      <figure class="image">
        <img
          :src="getImg"
          alt="Placeholder image"
        >
      </figure>
    </div>
    <div class="card-content">
      <div class="content has-text-centered">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      default: null
    },
    resourceType: {
      type: String,
      required: true
    },
    resourceId: {
      type: Number,
      required: true
    }
  },
  computed: {
    getImg () {
      return this.imageUrl ? this.imageUrl : require('../../assets/material-placeholder.jpg')
    }
  },
  methods: {
    handleClick (resourceType, resourceId) {
      this.$router.push({
        name: 'material',
        params: {
          resourceType: resourceType,
          resourceId: resourceId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.material-card {
  margin: 5px 10px 5px 10px;
  display: inline-block;
  width: 275px;
  cursor: pointer;
}

.image {
  width: 275px;
  height: 183px;
}

.image img {
  object-fit: contain;
  height: 100%;
}

</style>
